import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { useAuth } from '@clerk/clerk-react';
import { GET_LIVE_CONTEXT_STATE_QUERY_KEY } from '@/state/queries/player/use-get-live-context-state';

export type LayerCommandAction = 'perform' | 'hide';

export type LayerCommandRequest =
  | { action: 'perform'; entityRef: string; playerId?: string }
  | { action: 'hide'; itemIds: string[]; entityRef: string; playerId?: string };

export interface UseLayerCommandMutationOptions {
  onError?: (error: Error) => void;
}

export const useLayerCommandMutation = (options?: UseLayerCommandMutationOptions) => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: LayerCommandRequest) => {
      const token = await getToken();
      return layerCommand(body, token ?? '');
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [GET_LIVE_CONTEXT_STATE_QUERY_KEY, variables.entityRef],
      });
      void queryClient.refetchQueries({
        queryKey: [GET_LIVE_CONTEXT_STATE_QUERY_KEY, variables.entityRef],
      });
    },
    onError: options?.onError,
  });
};

const layerCommand = async (body: LayerCommandRequest, token: string): Promise<{ success: boolean }> => {
  const url = `${import.meta.env.VITE_API_URL}/player/layer-command`;
  return sendJSONRequest({ url, method: METHOD.POST, body, token });
};
